import Layout from '@/layout'
export default {
    meta: {
        title: '专家',
        icon: 'b-zz'
    },
    path: "/expert",
    component: Layout,
    children: [
        {
            path: '/expert/expert',
            name: 'expert',
            component: () => import('@/views/expert/expert.vue'),
            meta: {
                title: '专家库',
                auth: [],
                img: "zz"
            }
        },
    ]
}
